var _style, _defs, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 460 460",
    style: {
      enableBackground: "new 0 0 460 460"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000078745242900907553050000015268095924061908382_);}\n\t.st1{fill:#F8F8F8;}\n\t.st2{fill:url(#SVGID_00000051383471005530247080000002035888157590136251_);stroke:#F8F8F8;stroke-width:7;stroke-miterlimit:10;}\n\t.st3{fill:url(#SVGID_00000150784425635376707110000017204045233391698367_);stroke:#F8F8F8;stroke-width:7;stroke-miterlimit:10;}\n\t.st4{fill:url(#SVGID_00000114032511505445682420000000223378086417791897_);stroke:#F8F8F8;stroke-width:7;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -34,
    y: -34.5,
    width: 540,
    height: 540
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099631414312643545350000003386557749078504579_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000099631414312643545350000003386557749078504579_)"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 230.1,
    cy: 232,
    rx: 229.7,
    ry: 229.7
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000099631414312643545350000003386557749078504579_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143582924050192994840000016642461307419779489_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.6496,
    y1: 344.4191,
    x2: 279.1888,
    y2: 106.1942
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#0E246F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#0E406F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#5A59A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#575CA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#4F67A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#4279B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#3092C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#18B3DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#16B7E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143582924050192994840000016642461307419779489_)",
      stroke: "#F8F8F8",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M238.9,169.4c0,47.2,0,94.1,0,141.5c1.1,0,2.2,0,3.2,0c12.3,0,24.7,0,37,0c10.2,0,17,4.6,20.8,14c1.7,4.1,3.4,8.2,4.9,12.4 c3.9,10.4-2.7,20.4-13.8,20.4c-40.8,0.1-81.6,0.1-122.4,0c-10.9,0-17.6-10-13.8-20.2c1.7-4.4,3.5-8.8,5.3-13.2 c3.5-8.5,10.6-13.3,19.8-13.3c12.5,0,25.1,0,37.6,0c1.1,0,2.1,0,3.5,0c0-1.4,0-2.4,0-3.5c0-44.9,0-89.9,0-134.8 c0-2.2-0.4-3.3-2.8-4.3c-10.5-4.2-17.2-11.9-19.8-23c-0.5-2-1.2-2.7-3.2-2.9c-27-3.7-53.9-7.5-80.9-11.3 c-6.6-0.9-10.3-5.6-8.8-11.1c1.2-4.4,5.2-7.1,10.3-6.4c9,1.2,18,2.5,27,3.8c18.6,2.6,37.1,5.2,55.7,7.9c1.8,0.3,2.3-0.7,3-2 c6.7-11.6,16.9-17.6,30.3-16.8c12.7,0.7,21.8,7.4,27.3,18.8c0.8,1.7,1.7,3.5,1.8,5.3c0.2,3.1,1.9,3.7,4.5,4.1 c25.9,3.6,51.8,7.2,77.7,10.8c1.2,0.2,2.3,0.3,3.5,0.5c5.1,0.8,8.2,4.9,7.6,9.9c-0.5,4.5-4.6,7.9-9.5,7.4c-8-0.9-16-2.1-24.1-3.2 c-19.9-2.8-39.9-5.7-59.8-8.4c-0.7-0.1-2,0.4-2.3,1C254.5,161,247.8,166.5,238.9,169.4z M287.1,340c-1.2-2.9-2.3-5.3-3.1-7.9 c-0.9-2.8-2.5-3.7-5.5-3.7c-17.2,0.1-34.4,0.1-51.5,0.1c-15.5,0-31,0-46.5,0.1c-1.2,0-3,0.6-3.5,1.5c-1.6,3.1-2.8,6.4-4.2,10 C211.1,340,248.9,340,287.1,340z M229.8,153c8.3,0.1,14.8-6.5,14.8-14.9c0-7.7-6.6-14.2-14.5-14.3c-8.2-0.1-14.7,6.5-14.8,14.9 C215.3,146.4,222,152.9,229.8,153z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053513624168662249680000002204946159516577176_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.5077,
    y1: 282.2183,
    x2: 340.455,
    y2: 183.5827
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#0E246F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#0E406F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#5A59A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#575CA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#4F67A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#4279B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#3092C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#18B3DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#16B7E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053513624168662249680000002204946159516577176_)",
      stroke: "#F8F8F8",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M355.6,238.9c-0.5,26-20.7,46.6-47.1,48.5c-24,1.8-47-16.3-51.3-40.4c-0.5-2.7-1-5.5-1-8.2c0-2,0.5-4.2,1.5-5.9 c11.6-19.7,23.4-39.3,35.1-59c2.7-4.5,6.4-7.5,11.8-7.9c6.5-0.5,11.2,2.3,14.4,7.9c11.2,18.8,22.4,37.6,33.6,56.4 C354.4,233.2,356.3,235.8,355.6,238.9z M331.4,228.9c-8.6-14.4-16.9-28.3-25.4-42.6c-8.6,14.4-16.9,28.4-25.4,42.6 C297.8,228.9,314.3,228.9,331.4,228.9z M336.5,246.8c-20.4,0-40.7,0-61.1,0c2.6,13.1,16.7,23.3,31.5,23.1 C320.7,269.6,334.6,258.8,336.5,246.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104693302701178473410000003683233875177055668_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.5099,
    y1: 258.781,
    x2: 188.4234,
    y2: 160.2039
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#0E246F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#0E406F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#5A59A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#575CA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#4F67A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#4279B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#3092C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#18B3DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#16B7E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104693302701178473410000003683233875177055668_)",
      stroke: "#F8F8F8",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M153.8,264c-27.1-0.1-49.3-22-49.5-48.9c0-1.9,0.4-4,1.4-5.6c11.6-19.6,23.3-39.1,35-58.7c2.2-3.7,5.1-6.5,9.3-7.7 c6.7-1.9,13.1,0.8,17,7.4c8.8,14.6,17.5,29.3,26.2,44c2.9,4.9,5.8,9.9,8.9,14.7c2.6,4,1.6,8.3,1,12.4 C199.5,246.2,178.6,264.1,153.8,264z M128.6,205.5c17.1,0,33.7,0,50.8,0c-8.6-14.3-16.9-28.3-25.4-42.6 C145.4,177.3,137.1,191.2,128.6,205.5z M184.5,223.3c-20.5,0-40.8,0-61.1,0c1.9,12.3,16.2,23.2,30.4,23.3 C168,246.7,182.5,235.8,184.5,223.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScales);
export default __webpack_public_path__ + "static/media/scales.0e9f035b379a81875222487545641fda.svg";
export { ForwardRef as ReactComponent };